import { useTranslation } from 'react-i18next'

import Button from '@/components/Button/Button'
import KidCard from '@/components/Card/KidCard'
import UITitle from '@/components/UI/UITitle'
import { useAppState } from '@/composables/useAppState'
import type { Persona } from '@/state/AppConfig'
import { personas } from '@/state/AppConfig'

import SummaryBackground from './SummaryBackground'
import SummarySwirl from './SummarySwirl'

type SummaryNextChildrenProps = {
  onClickBackToTop: () => void
  leaving?: boolean
  setLeaving: (leaving: boolean) => void
}

export default function SummaryNextChildren({ onClickBackToTop, leaving, setLeaving }: SummaryNextChildrenProps) {
  const { t } = useTranslation()

  const { persona } = useAppState()

  const otherPersonas = personas.filter((p) => p !== persona)

  return (
    <footer className='SummaryNextChildren w-full relative pt-16 flex flex-col gap-160'>
      <SummarySwirl className={`w-full ${leaving ? 'transition-opacity duration-700 ease-out-quad opacity-0' : '0'}`} />
      <SummaryBackground
        is='div'
        background='background1'
        classNameInner='container pb-128 lg:pb-60'
        className={`${leaving ? 'transition-opacity duration-700 ease-out-quad opacity-0' : '0'}`}
        isLast={true}
      >
        <UITitle
          is='h2'
          i18nKey={`summary.meet.title`}
          className={`relative z-2 text-heading-h1 text-center mb-52 md:mb-16 col-start-1 col-span-10 lg:col-span-12 -mx-20 md:mx-0 ${leaving ? 'transition-opacity duration-700 ease-out-quad opacity-0' : '0'}`}
          hasScrollTrigger={true}
        />
        <div className='flex flex-col md:flex-row gap-20 col-start-1 col-span-10 md:col-start-2 md:col-span-8 lg:col-start-3 lg:col-span-8'>
          {otherPersonas.map((p, i) => (
            <KidCard persona={p as Persona} leaving={leaving} setLeaving={setLeaving} key={i} />
          ))}
        </div>
        <div
          className={`col-start-1 col-span-10 md:col-start-2 md:col-span-8 lg:col-start-1 lg:col-span-12 flex justify-center mt-80 ${leaving ? 'transition-opacity duration-700 ease-out-quad opacity-0' : '0'}`}
        >
          <Button variant='secondary' onClick={onClickBackToTop}>
            {t('summary.backToTop')}
          </Button>
        </div>
      </SummaryBackground>
    </footer>
  )
}
